export default __webpack_public_path__ + "static/media/liza-crepped.60ad68a7.png";